/**
 * Formats role names to be more readable
 * Examples:
 * - super_admin -> Super Admin
 * - moder -> Moder
 * - finance -> Finance
 * - support -> Support
 */
export const formatRoleName = (roleName: string): string => {
  return roleName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
